import React, { Component } from "react";
import "../Styles/SvgCommand.css";

const NextIcon = (props) => {
  return (
    <svg
      className="svgNew"
      baseProfile="tiny"
      id="Layer_1"
      version="1.2"
      viewBox="0 0 32 32"
      height="24px"
      width="24px"
      onClick={() => props.onClick()}
    >
      <g data-name="Layer 2" id="Layer_2">
        <path d="M12,25a1,1,0,0,1-.71-.29,1,1,0,0,1,0-1.42L18.59,16l-7.3-7.29a1,1,0,1,1,1.42-1.42l8,8a1,1,0,0,1,0,1.42l-8,8A1,1,0,0,1,12,25Z" />
      </g>
    </svg>
  );
};

export default NextIcon;
